module.exports = __webpack_public_path__ + "img/1434643612.db7fce70.jpg";